document.addEventListener('DOMContentLoaded', () => {
  function initTabs(tabSelector, contentPrefix) {
    const buttons = document.querySelectorAll(tabSelector);
    const contents = document.querySelectorAll(`[id^="${contentPrefix}"]`);

    if (buttons.length) {
      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const tabId = btn.getAttribute('data-tab');

          // Reset all
          buttons.forEach((b) => b.classList.remove('active', 'opacity-[0.5]'));
          contents.forEach((c) => c.classList.add('!hidden'));

          // Activate clicked tab
          btn.classList.add('active');
          btn.classList.remove('opacity-[0.5]');

          const activeTab = document.getElementById(tabId);

          if (activeTab) {
            activeTab.classList.remove('!hidden');
            initSwiperForTab(activeTab);
          }
        });
      });
      // Initialize first tab
      buttons[0].classList.add('active');
      contents[0].classList.remove('!hidden');
    }
    initSwiperForTab(contents[0]);
  }

  initTabs(".tab-btn[data-tab^='tab-']", 'tab-');

  function initSwiperForTab(tabEl) {
    const productSlides = tabEl.querySelectorAll('.swiper-slide');
    const nextBtn = tabEl.querySelector('.collection-tabs .swiper-button-next');
    const prevBtn = tabEl.querySelector('.collection-tabs .swiper-button-prev');
    let mql = window.matchMedia('(width > 900px)');

    // Show buttons by default (but CSS may override for mobile)
    if (nextBtn) nextBtn.style.setProperty('display', 'block');
    if (prevBtn) prevBtn.style.setProperty('display', 'block');

    // Hide buttons on desktop when there are fewer than 4 slides
    if (mql.matches && productSlides.length < 4) {
      if (nextBtn) nextBtn.style.setProperty('display', 'none', 'important');
      if (prevBtn) prevBtn.style.setProperty('display', 'none', 'important');
    }

    if (tabEl.swiperInstance) {
      tabEl.swiperInstance.destroy(true, true);
    }

    tabEl.swiperInstance = new Swiper(tabEl.querySelector('.featured-products'), {
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      slidesPerView: 'auto',
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 'auto',
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          spaceBetween: 4,
        },
      },
    });
  }
});
